import { z } from 'zod';

import { REQUIRED_VALIDATION_MESSAGE } from 'src/constants/validationMessage';

import { EmailSearchFormFields } from './constants';
import type { EmailSearchFormValues } from './types';

export const emailSearchFormValidationSchema = z.object({
  [EmailSearchFormFields.email]: z.email().nonempty({ error: REQUIRED_VALIDATION_MESSAGE }),
}) satisfies z.ZodType<EmailSearchFormValues>;
